<script setup lang="ts">
import {
  IonButton,
  getPlatforms,
  isPlatform,
  useIonRouter,
} from '@ionic/vue'
import { useI18n } from 'vue-i18n'
import { onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import LeftArrowIcon from './svg/LeftArrowIcon.vue'
import AddIcon from './svg/AddIcon.vue'
import StoreRedirector from './StoreRedirector.vue'
import TextBubble from './TextBubble.vue'
import ListIcon from '@/components/svg/ListIcon.vue'
import { useUserStore } from '@/store/user'
import { useAuthStore } from '@/store/auth'
import { useGlobalStateStore } from '@/store/globalState'

interface Props {
  isSingleSekai?: boolean
}
defineProps<Props>()

const { t } = useI18n()
const router = useIonRouter()
const userStore = useUserStore()
const authStore = useAuthStore()
const globalStateStore = useGlobalStateStore()
const { showCreateSekaiGuide } = storeToRefs(globalStateStore)

const showStoreRedirect = ref(false)

function routeBack() {
  if (router.canGoBack()) {
    router.back()
  }
  else {
    router.push('/')
  }
}

onMounted(() => {
  // check if the mobile web
  console.debug(isPlatform('desktop'))
  console.debug(getPlatforms())
  if (isPlatform('mobileweb')) {
    showStoreRedirect.value = true
  }
})
</script>

<template>
  <div
    id="page-header-wrapper"
    class="flex-shrink-0 w-full pt-unsafe-area pb-3 flex flex-col gap-4 absolute top-0 left-0 page-header z-200"
  >
    <store-redirector v-if="showStoreRedirect" />
    <div class="relative pt-1.5 flex justify-between items-center px-1">
      <ion-button
        v-if="isSingleSekai"
        size="small"
        fill="clear"
        @click="
          () => {
            routeBack();
          }
        "
      >
        <left-arrow-icon />
      </ion-button>
      <ion-button
        v-else
        size="small"
        fill="clear"
        @click="() => {
          router.push('/menu')
        }"
      >
        <list-icon />
      </ion-button>
      <span class="relative text-5 fw-700 leading-7 text-on-bg-1">
        {{ isSingleSekai ? "" : t("pageHeader.forYou") }}
      </span>
      <ion-button
        v-if="!isSingleSekai"
        size="small"
        fill="clear"
        @click="
          () => {
            if (!userStore.isLoggedIn) {
              authStore.openModal();
            }
            else {
              globalStateStore.setShowCreateSekaiGuide(false)
              router.push('/create-universe');
            }
          }
        "
      >
        <add-icon class="w-6 h-6 color-#fff" />
      </ion-button>
      <div
        v-if="showCreateSekaiGuide && !isSingleSekai"
        class="absolute top-12 right-2.5"
      >
        <text-bubble
          text="Tap here to create new sekai"
          position="top-right"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.page-header {
  background: linear-gradient(
    180deg,
    rgba(21, 21, 21, 0.1) 87.74%,
    rgba(21, 21, 21, 0.1) 100%
  );
}

.bg {
  background: rgba(255, 255, 255, 0.5);
}
</style>
